import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'
import { reportActions } from '../../actions'
import { Grid, Content } from '../../components/Layout'
import Sidebar from '../../components/Sidebar'
import Header from '../../components/Header'
import Table from '../../components/Table'
import { Input, Button } from '../../components/Form'
import { InvoiceModal } from '../../components/Inventory'
import { ReportPicker } from '../../components/Inventory'
import { SimpleLoader } from '../../components/loaders'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import statusSuccessIcon from '../../assets/icons/status-success.svg'
import lockedIcon from '../../assets/icons/locked.svg'
import SeeInvoice from '../../assets/icons/visibility.svg'
import ContentHeader from '../../components/ContentHeader'

const MonthButton = styled(Button)`
  width: 80%;
  margin-top: 20px;
`

const ApproveMonthButton = styled(MonthButton)`
  margin-left: 2.5%;
  margin-bottom: 20px;
  background-color: ${color.secondary};
  border: 0;
  max-width: 150px;
  &:disabled {
    cursor: default;
  }
`

const CloseMonthButton = styled(MonthButton)`
  background-color: ${color.secondary};
  border: 0;
  margin: 20px;
  width: 250px;
  &:disabled {
    cursor: default;
  }
`

const OpenMonthButton = styled(MonthButton)`
  background-color: ${color.secondary};
  border: 0;
  margin: 20px;
  width: 250px;
  &:disabled {
    cursor: default;
  }
`

const CloseContent = styled.div`
  display: flex;
  margin: 20px;
  justify-content: flex-end;
  span {
    text-align: center;
  }
`

const CloseContentForm = styled.form`
  display: flex;
  flex-direction: column;
  span {
    text-align: center;
  }
`

const OpenContentForm = styled.form`
  display: flex;
  flex-direction: column;
  span {
    text-align: center;
  }
`

const OpenContent = styled.div`
  display: flex;
  margin: 20px;
  justify-content: flex-end;
  span {
    text-align: center;
  }
`

const ContentFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0 0 0;
  padding: 5px;
  margin-bottom: ${pxToRem(35)};
  background: #fff;
  h1,
  h2,
  strong {
    margin: 0;
    padding: 0;
  }
  h2 {
    font-size: ${pxToRem(16)};
    font-style: italic;
    margin-top: ${pxToRem(5)};
  }
  h1 {
    font-size: ${pxToRem(21)};
  }
  strong {
    font-size: ${pxToRem(19)};
  }
  form {
    display: block;
    width: 650px;
    margin: 20px;
  }

  @media only screen and (max-width: 700px) {
    h2 {
      font-size: ${pxToRem(13)};
    }
    h1 {
      font-size: ${pxToRem(17)};
    }
    strong {
      font-size: ${pxToRem(15)};
    }
  }

  div:last-child {
    text-align: left;
    span {
      text-transform: capitalize;
      display: block;
      margin-top: ${pxToRem(5)};
      font-size: ${pxToRem(18)};
    }
  }

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    div:last-child {
      text-align: left;
      margin-top: ${pxToRem(20)};
    }
  }
`

const AproveContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const WrapperInvoice = styled.div`
  display: flex;
  justify-content: center;
  img {
    position: absolute;
    margin: auto;
  }
`

const InvoiceButton = styled(Button)`
  background: url(${props => props.icon});
  border: none;
  background-repeat: no-repeat;
  background-position: center center;
  width: ${pxToRem(25)};
  height: ${pxToRem(25)};
  cursor: pointer;
`

const Status = styled.div`
  visibility: ${props => (props.visibility ? 'visible' : 'hidden')};
  width: 40px;
  height: 25px;
  margin: auto;
  padding: auto;
  background: #4de86c;
  border-radius: 180px;
  display: flex;
  justify-content: center;
`

const LockedIcon = styled.img`
  margin-left: 10px;
  visibility: ${props => (props.visibility ? 'visible' : 'hidden')};
`

class Report extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounce: undefined,
      openInvoiceModal: false,
      productId: null,
      productName: null
    }
  }

  componentDidMount() {
    const {
      fetchAvailableReports,
      fetchReportList,
      currentAreaId,
      areaResponsible,
      businessUnitResponsible,
      reportList,
      lastUpdate,
      currentReport,
      availableReports
    } = this.props

    fetchAvailableReports(currentAreaId)
  }

  componentDidUpdate(prevProps) {
    const { currentAreaId, currentReport, fetchAvailableReports, fetchReportList } = this.props

    if (currentAreaId && prevProps.currentAreaId !== currentAreaId) {
      const debounce = setTimeout(() => {
        fetchAvailableReports(currentAreaId)
        fetchReportList(currentAreaId, currentReport.month, currentReport.year)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    if ((prevProps.currentReport || {}).label !== (currentReport || {}).label) {
      const debounce = setTimeout(() => {
        fetchReportList(currentAreaId, currentReport.month, currentReport.year)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  areaResponsibleApprove = e => {
    e.preventDefault()
    const type = 'area'
    const { currentReport = {} } = this.props
    this.props.responsibleApproveMonth({
      areaId: this.props.currentAreaId,
      month: currentReport.month,
      year: currentReport.year,
      type
    })
  }

  unitResponsibleApprove = e => {
    e.preventDefault()
    const type = 'business_unit'
    const { currentReport = {} } = this.props
    this.props.responsibleApproveMonth({
      areaId: this.props.currentAreaId,
      month: currentReport.month,
      year: currentReport.year,
      type
    })
  }

  openModalInvoice = async (event, row) => {
    event.preventDefault()
    const { currentReport = {} } = this.props
    const response = await reportActions.getInvoiceList(
      this.props.currentAreaId,
      row.product_id,
      currentReport.month,
      currentReport.year
    )
    this.setState(state => ({
      invoiceList: response.invoices,
      openInvoiceModal: true,
      productId: row.product_id,
      productName: row.product_name
    }))
  }

  closeModalInvoice = () => {
    this.setState(state => ({
      openInvoiceModal: false,
      productId: null,
      productName: null
    }))
  }

  closeMonth = e => {
    e.preventDefault()
    const { currentAreaId, currentReport = {} } = this.props
    this.props
      .closeMonth({
        areaId: currentAreaId,
        month: currentReport.month,
        year: currentReport.year
      })
      .then(() => {
        this.props.fetchAvailableReports(currentAreaId)
      })
  }

  openMonth = e => {
    e.preventDefault()
    const { currentAreaId, currentReport = {} } = this.props
    this.props
      .openMonth({
        areaId: currentAreaId,
        month: currentReport.month,
        year: currentReport.year
      })
      .then(() => {
        this.props.fetchAvailableReports(currentAreaId)
      })
  }

  render() {
    const columns = {
      product_id: {
        hide: true
      },
      observation: {
        hide: true
      },
      product_name: {
        label: 'Produto',
        sortable: true,
        width: pxToRem(100)
      },
      last_month_amount_with_measure: {
        label: 'QTD. Do Mês Anterior',
        sortable: true,
        width: pxToRem(100)
      },
      month_amount_with_measure: {
        label: 'QTD. De Compra No Mês',
        sortable: true,
        width: pxToRem(100)
      },
      invoice: {
        label: 'NF',
        sortable: true,
        width: pxToRem(20),
        align: 'center',
        CellComponent: ({ product: column, row, ...rest }) => {
          let item = {}

          item = {
            icon: SeeInvoice,
            value: 's'
          }
          return (
            <WrapperInvoice type={item.value}>
              <InvoiceButton
                icon={item.icon}
                alt={item.value}
                onClick={e => this.openModalInvoice(e, row)}
              />
            </WrapperInvoice>
          )
        }
      },
      consumed_amount_with_measure: {
        label: 'QTD. Consumida',
        sortable: true,
        width: pxToRem(100)
      },
      final_amount_with_measure: {
        label: 'Estoque',
        sortable: true,
        width: pxToRem(100)
      }
    }

    const {
      router,
      menuItems,
      areaResponsible,
      businessUnitResponsible,
      reportList,
      lastUpdate,
      availableReports,
      currentReport,
      fetching,
      fetch_errors,
      fetchReportList
    } = this.props

    const { areaResponsibleApprove, unitResponsibleApprove, closeModalInvoice } = this

    const { openInvoiceModal, productName, productId, invoiceList } = this.state
    return (
      <Fragment>
        <Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content>
            <ContentHeader
              title="Produtos Químicos"
              subtitle="Relatório"
              margin="20"
              lastUpdate={lastUpdate}
            >
            </ContentHeader>
            {availableReports.length ? (
              <ReportPicker availableReports={availableReports} />
            ) : <SimpleLoader />}
            <Table
              loading={fetching.ReportList}
              error={fetch_errors.ReportList}
              fetchData={fetchReportList}
              columns={columns}
              height={'25vh'}
              width={1100}
              data={(reportList || []).map(item => {
                return item
              })}
            />
            {!!areaResponsible && (
              <ContentFooter>
                <div>
                  <form>
                    <span>{process.env.REACT_APP_AREA_RESPONSIBLE_LABEL || 'Responsável Local'}:</span>
                    <AproveContent>
                      <Input value={(areaResponsible || {})['name'] || ''} readonly={'readonly'} />
                      <Status visibility={(areaResponsible || {})['approved']}>
                        <img src={statusSuccessIcon} />
                      </Status>
                      <ApproveMonthButton
                        disabled={
                          !(areaResponsible || {})['current_user_responsible'] ||
                          (areaResponsible || {})['approved']
                        }
                        onClick={e => areaResponsibleApprove(e)}
                      >
                        Aprovar
                      </ApproveMonthButton>
                      <LockedIcon
                        src={lockedIcon}
                        alt={'locked icon'}
                        visibility={(areaResponsible || {})['approved']}
                      />
                    </AproveContent>
                  </form>
                  <form>
                    <span>{process.env.REACT_APP_BUSINESS_UNIT_RESPONSIBLE_LABEL || 'Responsável Corporativo'}:</span>
                    <AproveContent>
                      <Input
                        value={(businessUnitResponsible || {})['name'] || ''}
                        readonly={'readonly'}
                      />
                      <Status visibility={(businessUnitResponsible || {})['approved']}>
                        <img src={statusSuccessIcon} />
                      </Status>
                      <ApproveMonthButton
                        disabled={
                          !(businessUnitResponsible || {})['current_user_responsible'] ||
                          (businessUnitResponsible || {})['approved']
                        }
                        onClick={e => unitResponsibleApprove(e)}
                      >
                        Aprovar
                      </ApproveMonthButton>
                      <LockedIcon
                        src={lockedIcon}
                        alt={'locked icon'}
                        visibility={(businessUnitResponsible || {})['approved']}
                      />
                    </AproveContent>
                  </form>
                </div>
                {currentReport.locked ? (
                  <OpenContentForm>
                    <OpenContent>
                      <OpenMonthButton
                        disabled={!(areaResponsible || {})['approved']}
                        onClick={e => this.openMonth(e)}
                      >
                        Abrir Mês
                      </OpenMonthButton>
                    </OpenContent>
                  </OpenContentForm>
                ) : (
                  <CloseContentForm>
                    <CloseContent>
                      <CloseMonthButton
                        disabled={!(areaResponsible || {})['approved']}
                        onClick={e => this.closeMonth(e)}
                      >
                        Fechar Mês
                      </CloseMonthButton>
                    </CloseContent>
                  </CloseContentForm>
                )}
              </ContentFooter>
            )}
            <InvoiceModal
              title="Nota Fiscal"
              productName={productName}
              open={openInvoiceModal}
              size="large"
              closeMethod={closeModalInvoice}
              productId={productId}
              invoiceList={invoiceList}
            />
            <ResponsiblesContent />
          </Content>
        </Grid>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.auth.userName,
  currentUserId: state.auth.userId,
  currentArea: state.auth.areaName,
  currentAreaId: state.auth.areaId,
  fetching: state.report.fetching,
  fetch_errors: state.report.fetch_errors,
  areaResponsible: state.report.areaResponsible,
  reportList: state.report.reportList,
  businessUnitResponsible: state.report.businessUnitResponsible,
  availableReports: state.report.available_reports,
  lastUpdate: state.report.last_update,
  currentReport: state.report.current_report
})

const mapDispatchToProps = dispatch => {
  return {
    fetchReportList: (areaId, month, year) => {
      return dispatch(reportActions.fetchReportList(areaId, month, year))
    },
    responsibleApproveMonth: ({ areaId, month, year, type }) => {
      return dispatch(reportActions.responsibleApproveMonth({ areaId, month, year, type }))
    },
    closeMonth: ({ areaId, month, year }) => {
      return dispatch(reportActions.closeMonth({ areaId, month, year }))
    },
    openMonth: ({ areaId, month, year }) => {
      return dispatch(reportActions.openMonth({ areaId, month, year }))
    },
    fetchAvailableReports: areaId => {
      return dispatch(reportActions.getAvailableReports(areaId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Report)



// WEBPACK FOOTER //
// ./src/containers/Inventory/Report.js